import { render, staticRenderFns } from "./authenticationInfo.vue?vue&type=template&id=22f68611&scoped=true&"
import script from "./authenticationInfo.vue?vue&type=script&lang=js&"
export * from "./authenticationInfo.vue?vue&type=script&lang=js&"
import style0 from "./authenticationInfo.vue?vue&type=style&index=0&id=22f68611&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f68611",
  null
  
)

export default component.exports